import React from "react";
import {  fn_send_change_data } from "./FnBodyStep";
import { fn_orderDetail, fn_removeOrderNew } from "./FnBodyDetail";
import { fn_bridge_order_cancel } from "./FnPosBridge";
import {
  api_order_list_get_page,
  api_order_search_list,
  reload_order_list_all,
  api_order_type,
} from "../http/OrderConn";

//pos call 주문 거절
export function fn_pos_reject_order_push(rootStore, mobileOrderNo) {
  rootStore.layerStore.setLayerAlertView(false);
  let cnt = 0;
  if (rootStore.settingStore.getManagerSetting?.orderEnd == "Y") {
    rootStore.settingStore.setManagerSetting("orderEnd", "N");
  }

  rootStore.layerStore.setPosnotiReject(true);

  //기타로 거절 처리.
  fn_removeOrderNew(rootStore, mobileOrderNo);
  api_order_list_get_page(rootStore, mobileOrderNo).then((r) => {
    api_order_search_list(rootStore).then((r) => {
      rootStore.viewStore.setOrderDetail(
        rootStore.orderStore.getOrderList,
        mobileOrderNo
      );
      rootStore.layerStore.setChangeCancelReason("C5");
      rootStore.layerStore.setLayerAlertType(false);
      fn_bridge_order_cancel(rootStore);
    });
  });
}

//pos call 주문 수락
export function fn_pos_accept_order_push(rootStore, mobileOrderNo, min) {
  if (rootStore.settingStore.getManagerSetting?.orderEnd == "Y") {
    rootStore.settingStore.setManagerSetting("orderEnd", "N");
  }
  fn_removeOrderNew(rootStore, mobileOrderNo);
  api_order_list_get_page(rootStore, mobileOrderNo).then((r) => {
    api_order_search_list(rootStore).then((r) => {
      rootStore.viewStore.setOrderDetail(
        rootStore.orderStore.getOrderList,
        mobileOrderNo
      );
      rootStore.layerStore.setChangeCstTime(min);
      rootStore.layerStore.setLayerAlertType(false);
      //fn_send_change_data(rootStore, '200');
      reload_order_list_all(rootStore);
    });
  });
}

//pos call 주문 상세 출력
export function fn_pos_order_detail_view(rootStore, mobileOrderNo, min) {
  fn_removeOrderNew(rootStore, mobileOrderNo);
  rootStore.viewStore.setOrderDetail(
    rootStore.orderStore.getOrderList,
    mobileOrderNo
  );
  rootStore.layerStore.setChangeCstTime(min);
  fn_send_change_data(rootStore, "200");
}
export function fn_pos_order_init_list_page() {
  window.location.href = "/order_list";
}

export function fn_pos_user_info_push(rootStore, userId, userNm, auth) {
  rootStore.settingStore.setUserInfo("userId", userId);
  rootStore.settingStore.setUserInfo("userNm", userNm);
  rootStore.layerStore.setManagerAuthView(
    "manager",
    localStorage.getItem("auth")
  );
}

// 주문 상세보기 레이어 열기
export function fn_search_orderDetail(rootStore, mobileOrderNo, type) {
  if (rootStore.settingStore.getManagerSetting?.orderEnd == "Y") {
    rootStore.settingStore.setManagerSetting("orderEnd", "N");
  }
  api_order_list_get_page(rootStore, mobileOrderNo).then((r) => {
    api_order_search_list(rootStore).then((r) => {
      api_order_type(rootStore);
      fn_orderDetail(rootStore, mobileOrderNo, type);
    });
  });
}

// 배민 서비스 상태 체크
export function fn_baemin_service_statue(rootStore, data) {
  rootStore.settingStore.setBaeminStatus(data);
}
